<template>
	<div v-if="model" class="overlay-link">
		<a ref="targetLink" href="#" 
		v-bind:class="[ 'overlay-toggle', { image: image, 'has-icon': model.link_text, video: isVideo }]"  
		v-global-overlay="{ model: model, requestPath: requestPath, dark: dark, index: index }">
			<figure v-if="image" :class="{ video: isVideo }">
				<div :class="{ 'video-image-wrapper': isVideo }">
					<img v-bind:src="image.src" v-bind:alt="image.alt" />
				</div>
				<figcaption v-if="caption" v-html="sanitizedCaption"></figcaption>
			</figure>
			<span class="label" v-if="label && !caption" v-html="sanitizedLabel"></span>
			<span v-if="hasIcon!==false && !image && !caption" ref="targetIcon" class="plus-or-close"></span>
		</a>
	</div>
</template>

<script>
import DOMPurify from 'dompurify';
export default {
	props: ['requestPath', 'image', 'model', 'index', 'dark', 'linkText', 'hasIcon'],
	computed: {
		caption() {
			if (typeof this.model[0] === 'undefined' || typeof this.model[0].caption === 'undefined') return false;
			return this.model[0].caption;
		},
		sanitizedCaption() {
			if (this.caption===false) return false;
			return DOMPurify.sanitize(this.caption);
		},
		isVideo: function() {
			if (typeof this.model[0]==='undefined') return false;
			var layout = this.model[0].acf_fc_layout;
			return (layout === 'youtube_video' || layout === 'vimeo_video');
		},
		label() {
			if (this.linkText) return this.linkText;
			if (this.model.link_text) return this.model.link_text;
			if (this.model.number && this.model.title) return this.model.number + '. ' + this.model.title;
			return false;
		},
		sanitizedLabel() {
			if (this.label===false) return false;
			return DOMPurify.sanitize(this.label);
		}
	}
}
</script>

<style lang="scss">
  @import "../../styles/scss/global/overlay";
  @import "../../styles/scss/component/overlay/link";
</style>